import { useTranslation } from "react-i18next";

export default function StoreFooter() {
    const { t } = useTranslation();
    const appStoreURL =
        "https://apps.apple.com/us/app/zabehaty-%D8%B0%D8%A8%D9%8A%D8%AD%D8%AA%D9%8A/id1227769641";
    const playStoreURL =
        "https://play.google.com/store/apps/details?id=com.atp.zabehati";

    return (
        <>
            {" "}
            <footer className="bg-[#171717] px-6 py-10 text-white">
                <div className="mx-auto grid max-w-6xl grid-cols-1 items-start gap-8 md:grid-cols-3">
                    {/* Logo */}
                    <div className="flex justify-center md:justify-start">
                        <img
                            src="/store/store_logos/logo1.svg"
                            alt="Zabehaty Footer Logo"
                            className="h-32 object-contain"
                        />
                    </div>

                    {/* About and links */}
                    <div className="text-center md:text-left">
                        <p className="mb-3 text-xl font-semibold">
                            {t("about")}
                        </p>
                        <nav className="flex flex-col space-y-2 text-lg">
                            <a href="/" className="text-base hover:underline">
                                {t("home")}
                            </a>
                            <a
                                href="/about"
                                className="text-base hover:underline"
                            >
                                {t("about-us")}
                            </a>
                        </nav>

                        {/* App/Play Store Icons */}
                        <div className="mt-4 flex justify-center gap-4 md:justify-start">
                            <a
                                href={appStoreURL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group relative inline-block"
                            >
                                <img
                                    src="/store/logos/appstore_icon.svg"
                                    alt="App Store"
                                    className="transition-opacity duration-300 group-hover:opacity-0"
                                />
                                <img
                                    src="/store/logos/appstore_hovericon.svg"
                                    alt="App Store Hover"
                                    className="absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                                />
                            </a>
                            <a
                                href={playStoreURL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="group relative inline-block"
                            >
                                <img
                                    src="/store/logos/playstore_icon.svg"
                                    alt="Play Store"
                                    className="transition-opacity duration-300 group-hover:opacity-0"
                                />
                                <img
                                    src="/store/logos/playstore_hovericon.svg"
                                    alt="Play Store Hover"
                                    className="absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                                />
                            </a>
                        </div>
                    </div>

                    {/* Contact/Address */}
                    <div className="space-y-2 text-center md:text-left">
                        <p className="text-xl font-semibold">
                            {t("contact-details")}
                        </p>
                        <p className="text-base">{t("zabehaty-address")}</p>
                        <p className="text-base underline">+971 54 443 1382</p>
                        <p className="text-base underline">info@zabehaty.com</p>
                    </div>
                </div>

                {/* Bottom bar */}
                <hr className="my-6 border-gray-700" />
                <div className="text-center text-sm text-gray-400">
                    {t("imprint-privacy")}
                </div>
            </footer>
        </>
    );
}
